import i18n from 'i18next';
import { AssetLinkDaysOfTheWeekArraySchema } from 'pos-shared/models/resourceManagementSchema.ts';
import {
  type AssetLinkDaysOfTheWeekArrayModel,
  type AssetLinkDaysOfTheWeekModel,
} from 'pos-shared/models/routeSchema.ts';

interface DayOption {
  label: string;
  value: string;
}

export const daysOfWeekOptions = [
  { label: i18n.t('common.date.mondayAbbreviated'), value: 'monday' },
  { label: i18n.t('common.date.tuesdayAbbreviated'), value: 'tuesday' },
  { label: i18n.t('common.date.wednesdayAbbreviated'), value: 'wednesday' },
  { label: i18n.t('common.date.thursdayAbbreviated'), value: 'thursday' },
  { label: i18n.t('common.date.fridayAbbreviated'), value: 'friday' },
  { label: i18n.t('common.date.saturdayAbbreviated'), value: 'saturday' },
  { label: i18n.t('common.date.sundayAbbreviated'), value: 'sunday' },
];

export const getDaysObject = (
  selectedDays: string[]
): Record<string, boolean> => {
  return daysOfWeekOptions.reduce(
    (acc: Record<string, boolean>, dayOption: DayOption) => {
      acc[dayOption.value] = selectedDays.includes(dayOption.value);
      return acc;
    },
    {}
  );
};

export const getDaysArray = (selectedDays?: AssetLinkDaysOfTheWeekModel) => {
  const weekdayKeys =
    AssetLinkDaysOfTheWeekArraySchema.options as AssetLinkDaysOfTheWeekArrayModel[];

  return weekdayKeys.filter((day) => selectedDays?.[day]);
};
